<template>
	<div class="row-no-full" v-loading="loading">
		<div class="search_input">
			<el-input autosize type="textarea" placeholder="请输入信息" v-model="chatgpt_chatCompletions">
			</el-input>
		</div>
		<div style="margin-left: 10px;">
			<el-button @click="submit()" size="small" type="info">查询</el-button>
		</div>
	</div>
	<div>
		<el-card class="box-card">
			<div style="white-space: pre-wrap;" class="text item">{{changeLine(response)}}</div>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'chatCompletionsModel',
		data() {
			return {
				chatgpt_chatCompletions: '',
				loading: false,
				response: '暂无数据',

			}
		},
		methods: {
			changeLine(str) {
				return str.replace(/<br>/g, '\n')
			},
			submit() {
				// console.log(this.order_number);
				if (this.chatgpt_chatCompletions == '') {
					this.alertError('输入查询信息');
					return false;
				} else {
					this.loading = true;
					// return false
					this.httpPost({
						url: '/admin/chatgpt/chatCompletionsModel',
						data: {
							data: this.chatgpt_chatCompletions
						}
					}).then((re) => {

						console.log(re);
						this.response = re.data
						this.loading = false;
						this.alertSuccess(re.msg);
						// this.resetObj(this.order_number)
					})
				}
			},
		},
		created() {

		}
	}
</script>

<style scoped>
	.text {
		font-size: 14px;
	}

	.item {
		padding: 18px 0;
	}

	.box-card {
		width: 480px;
		margin-top: 20px;
	}
</style>
